import {RegionCode} from '../../backend/enums/region-code';
import {translations} from '../../i18n/translations';

/**
 * Array with the available regions in the Backend.
 *
 * Note: The property 'translation' gives the translation path to be used with i18n.
 * Example: t(regions[0].translation)
 * We don't return the translated value, because once set the values won't change.
 * Thus, if the user updates his language on the profile, the values given by this
 * array won't change and translate to the new language set by the user.
 */
export const regions: Array<{translation: string; type: RegionCode}> = [
  {translation: translations.regions[RegionCode.PT], type: RegionCode.PT},
  {translation: translations.regions[RegionCode.ES], type: RegionCode.ES},
  {translation: translations.regions[RegionCode.GL], type: RegionCode.GL},
  {translation: translations.regions[RegionCode.BR], type: RegionCode.BR},
];
